<template>
  <div
    :class="[
      'column position-relative',
      colType,
      {
        answer: cell.isAnswer,
      },
    ]"
    :style="{ height: `${cell.height}%` }"
  >
    <template v-if="cell.children && cell.children.length > 0">
      <puzzle-cell
        v-for="c_cell in cell.children"
        :key="c_cell.positiony + c_cell.positionx"
        :cell="c_cell"
      />
    </template>
    <template v-else>
      <p
        :style="{ fontSize: !cell.isAnswer ? `${cell.settings.font_size}px` : null}"
      >{{ cell.text }}</p>
    </template>
    <div
      v-if="cell.arrow_position && cell.arrow_position.slug"
      :class="['arrow', `position_${cell.arrow_position.slug}`]"
    >
      <div
        v-if="cell.arrow_direction && cell.arrow_direction.slug"
        :class="['arrow', `direction_${cell.arrow_direction.slug}`]"
      ></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'puzzle-cell',
  props: {
    cell: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
      require: false,
      default: 0,
    },
  },
  computed: {
    colType() {
      const types = {
        col: 'column',
        row: 'line',
        colspan: 'colspan',
        rowspan: 'rowspan',
        row_rowspan: 'rowspan line',
        colspan_row: 'colspan line',
        colspan_col: 'colspan colspan_col',
      };
      return types[this.cell.type];
    },
  },
  methods: {
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
$colorArrow: #000;
$colorBorder: #333;
.ball {
    content: '';
    border: 1.5px solid $colorArrow;
    border-radius: 50%;
    background-color: $colorArrow;
    height: 1px;
    width: 1px;
    position: absolute;
    top: -1px;
}
.puzzle {
  .column {
    border: 1px solid $colorBorder;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    width: 100%;
    padding: 2px;
    line-height: 1;
    cursor: pointer;
    &.line {
      flex-direction: column;
      padding: 0;
      margin: 0;
      .column {
        width: 100% !important;
        border-right: 0 !important;
        border-left: 0 !important;
        &:first-child {
          border-top: 0;
        }
        &:last-child {
          border-bottom: 0;
        }
      }
    }
    &.colspan {
      grid-column-end: span 2;
      .position_bottom {
        left: 25%;
      }
    }
    &.colspan_col {
      padding: 0;
      .column {
        border: 0;
        &:first-child {
          border-right: 2px solid $colorBorder !important;
        }
      }
    }
    &.rowspan {
      grid-row-start: span 2;
      display: flex;
      grid-auto-rows: 1fr;
      grid-auto-columns: 50px;
      word-wrap: break-word;
      padding: 0;
      .position_right {
        top: -25%;
      }
      .column {
        border-left: 0;
        border-right: 0;
      }
      .column:last-child {
        border-bottom: 0;
      }
      .column:first-child {
        border-top: 0;
      }
    }
    &.answer {
      font-size: 35px;
      font-weight: bold;
      font-family: Arial, Helvetica, sans-serif;
    }
    &.placeholder {
      color: #bbb;
    }
    p {
      margin: 0;
      overflow-wrap: break-word;
      word-break: keep-all;
      max-width: 102%;
      hyphens: auto;
      -webkit-hyphens: auto;
      -webkit-hyphenate-character: "\2010";
      -webkit-hyphenate-limit-after: 1;
      -webkit-hyphenate-limit-before: 3;
      -moz-hyphens: auto;
    }
  }
  .arrow {
    position: absolute;
    border-right: 1px solid $colorArrow;
    &.position {
      &_top {
        height: 7px;
        width: 1px;
        bottom: 100%;
        margin-bottom: 0px;
        &:before {
          @extend .ball;
          top: 100%;
          left: -1px;
        }
        &_diagonal_right {
          bottom: 110%;
          left: 91%;
          height: 1px;
          width: 20px;
          transform: rotate(-55deg);
          border-bottom: 1px solid $colorArrow;
          &:before {
            @extend .ball;
            left: -1px;
            top: -1px;
          }
          .direction_top {
            transform: rotate(55deg);
            top: -3px;
            left: 21px;
            &:before {
              top: -12px;
            }
          }
          .direction_right {
            transform: rotate(55deg);
            height: 1px;
            width: 6px;
            top: 2px;
            left: 19px;
            &::before {
              top: -3px;
              left: 6px;
            }
          }
        }
        &_diagonal_left {
          bottom: 113%;
          right: 93%;
          height: 1px;
          width: 20px;
          border-bottom: 1px solid $colorArrow;
          transform: rotate(55deg);
          &:before {
            @extend .ball;
            left: 20px;
            top: -1px;
          }
          .direction {
            &_top {
              transform: rotate(-55deg);
              top: -4px;
              right: 20px;
              left: auto;
              width: 1px;
              height: 6px;
              &:before {
                top: -12px;
                left: -3px;
              }
            }
            &_left {
              transform: rotate(-55deg);
              height: 1px;
              width: 6px;
              top: 2px;
              right: 17px;
              left: auto;
              border-bottom: 1px solid $colorArrow;
              &:before {
                top: -3px;
                left: auto;
                right: 5px;
              }
            }
          }
        }
        .direction {
          &_right {
            height: 1px;
            width: 6px;
            top: 0px;
            left: 0px;
            &::before {
              top: -3px;
              left: 6px;
            }
          }
          &_left {
            height: 1px;
            width: 6px;
            top: -1px;
            left: -5px;
            border-bottom: 1px solid $colorArrow;
            &::before {
              top: -3px;
              left: -12px;
            }
          }
          &_top {
            height: 0;
            width: 0;
            &::before {
              top: -10px;
              left: -10.5px;
            }
          }
        }
      }
      &_bottom {
        width: 1px;
        height: 10px;
        top: 100%;
        margin-top: -1px;
        &:before {
          @extend .ball;
          left: -1px;
        }
        &_diagonal {
          &_right {
            top: 108%;
            left: 91%;
            height: 1px;
            width: 18px;
            transform: rotate(55deg);
            border-bottom: 1px solid $colorArrow;
            &:before {
              @extend .ball;
              left: -1px;
            }
            .direction {
              &_bottom {
                transform: rotate(-55deg);
                top: -1px;
                left: 20px;
                width: 1px;
                height: 6px;
                &:before {
                  top: 6px;
                  left: -3px;
                }
              }
              &_right {
                transform: rotate(-55deg);
                height: 1px;
                width: 6px;
                top: -2px;
                left: 18px;
                &:before {
                  top: -3px;
                  left: 6px;
                }
              }
            }
          }
          &_left {
            top: 110%;
            right: 93%;
            height: 1px;
            width: 20px;
            transform: rotate(130deg);
            border-bottom: 1px solid $colorArrow;
            &:before {
              @extend .ball;
              top: -1px;
              left: -2px;
            }
            .direction {
              &_bottom {
                transform: rotate(230deg);
                top: -4px;
                right: -3px;
                left: auto;
                width: 1px;
                height: 6px;
                &:before {
                  top: 6px;
                  left: -2.5px;
                }
              }
              &_left {
                transform: rotate(230deg);
                height: 1px;
                width: 6px;
                top: 2px;
                right: -5px;
                left: auto;
                &:before {
                  top: -3px;
                  left: auto;
                  right: 6px;
                }
              }
            }
          }
        }
        &_secondColumn_right {
          width: 1px;
          height: 10px;
          top: 100%;
          margin-top: -1px;
          left: 75%;
          &:before {
            @extend .ball;
            left: -1px;
          }
        }
        .direction {
          &_right {
            height: 1px;
            width: 6px;
            top: 9px;
            left: 0px;
            &::before {
              top: -2.5px;
              left: 6px;
            }
          }
          &_left {
            height: 1px;
            width: 6px;
            top: 9px;
            left: -5px;
            border-bottom: 1px solid $colorArrow;
            &::before {
              top: -3px;
              left: -12px;
            }
          }
        }
      }
      &_left {
        right: 100%;
        height: 1px;
        width: 8px;
        border-bottom: 1px solid $colorArrow;
        &:before {
          @extend .ball;
          left: 7px;
        }
        .direction {
          &_top {
            left: auto;
            &:before {
              right: -2.8px;
              left: auto;
            }
          }
          &_left {
            &:before {
              right: 10px;
            }
          }
          &_bottom {
            width: 1px;
            height: 10px;
            right: 7px;
            &:before {
              top: 10px;
              right: 10px;
            }
          }
        }
      }
      &_right {
        left: 100%;
        height: 1px;
        width: 7px;
        border-bottom: 1px solid $colorArrow;
        &:before {
          @extend .ball;
          left: -2px;
        }
        &_secondRow_right {
          &:before {
            @extend .ball;
            left: -2px;
          }
          top: 75%;
          left: 100%;
          height: 1px;
          width: 7px;
          background: $colorArrow;
        }
        .direction {
          &_bottom {
            width: 1px;
            height: 10px;
            top: 0;
            left: 7px;
          }
        }
      }
    }
    &.direction {
      &_top {
        width: 1px;
        height: 4px;
        left: 8px;
        top: -2px;
        &:before {
          top: -8px;
          left: -3px;
          content: "";
          position: absolute;
          border-width: 3px 3px 9px 3px;
          border-style: solid;
          border-color: transparent transparent $colorArrow transparent;
        }
      }
      &_left {
        top: -2.7px;
        left: 10px;
        &:before {
          content: "";
          position: absolute;
          border-width: 3px 9px 3px 3px;
          border-style: solid;
          border-color: transparent $colorArrow transparent transparent;
        }
      }
      &_right {
        top: -2.5px;
        left: 7px;
        border-bottom: 1px solid $colorArrow;
        &:before {
          content: "";
          position: absolute;
          border-width: 3px 3px 3px 9px;
          border-style: solid;
          border-color: transparent transparent transparent $colorArrow;
        }
      }
      &_bottom {
        &:before {
          top: 10px;
          left: -2.6px;
          content: "";
          position: absolute;
          border-width: 9px 3px 3px 3px;
          border-style: solid;
          border-color: $colorArrow transparent transparent transparent;
        }
      }
    }
  }
}
</style>
